export const isPowerBi = (url: string): boolean => {
  return !!(
    url?.includes("app.powerbi.com") || url?.includes("powerbi.microsoft.com")
  );
};

export const isGeckoboard = (url: string): boolean => {
  return !!url?.includes("geckoboard.com");
};
